<!-- eslint-disable vue/html-closing-bracket-newline -->
<!-- eslint-disable vue/first-attribute-linebreak -->
<!-- eslint-disable vue/max-attributes-per-line -->
<!-- eslint-disable vue/html-indent -->

<template>
    <div class="absolute text-center w-full bottom-0 pr-3 mb-4 z-40">
        <div class="flex space-x-2 items-end mb-2 md:hidden">
            <!-- Field Type Selector -->
            <div class="flex-1 bg-cs-main-50 rounded-md p-2 border border-cs-main-500">
                <div class="flex items-center space-x-2">
                    <component :is="fieldIcons[drawField.type]" :width="20" :height="20" class="inline flex-shrink-0"
                        :stroke-width="1.6" />
                    <span class="text-sm flex-1">{{ fieldNames[drawField.type] }}</span>
                </div>
            </div>

            <!-- Field Type Dropdown Trigger -->
            <div v-if="editable" class="dropdown dropdown-top dropdown-end flex-shrink-0">
                <label tabindex="0"
                    class="bg-cs-main-50 cursor-pointer rounded-md p-2 border border-cs-main-500 flex justify-center items-center min-w-[44px]"
                    @click="toggleFieldTypeDropdown">
                    <IconChevronUp width="24" height="24" />
                </label>
                <ul v-show="renderFieldTypeDropdown" tabindex="0"
                    class="dropdown-content menu p-2 shadow-xl rounded-box bg-white mb-2 min-w-max border border-base-300"
                    style="z-index: 99999">
                    <li v-for="(icon, type) in fieldIconsSorted" :key="type">
                        <a href="#" class="flex px-2 group justify-between items-center"
                            :class="{ 'bg-cs-main-100 hover:bg-cs-main-200': type === drawField.type }"
                            @click.prevent="selectFieldType(type)">
                            <span class="py-1 flex items-center">
                                <component :is="icon" :width="20" :stroke-width="1.6" class="mr-2" />
                                <span>{{ fieldNames[type] }}</span>
                            </span>
                        </a>
                    </li>
                </ul>
            </div>

            <!-- Cancel Button -->
            <button
                class="bg-cs-main-50 cursor-pointer rounded-md p-2 border border-cs-main-500 flex justify-center items-center min-w-[44px]"
                @click.prevent="$emit('cancel')">
                <IconX width="24" height="24" />
            </button>
        </div>

        <FieldSubmitter :model-value="selectedSubmitter.uuid" :submitters="submitters" :editable="editable"
            :mobile-view="true"
            :menu-style="{ backgroundColor: ['', null, 'transparent'].includes(backgroundColor) ? 'white' : backgroundColor }"
            @new-submitter="save" @remove="removeSubmitter" @name-change="save"
            @update:model-value="$emit('change-submitter', submitters.find((s) => s.uuid === $event))" />
    </div>
</template>

<script>
import Field from './field'
import FieldType from './field_type'
import FieldSubmitter from './field_submitter'
import { IconChevronUp, IconX } from '@tabler/icons-vue'

export default {
    name: 'MobileDrawField',
    components: {
        Field,
        FieldSubmitter,
        IconChevronUp,
        IconX
    },
    inject: ['save', 't', 'backgroundColor', 'withPhone', 'withPayment', 'fieldTypes'],
    props: {
        drawField: {
            type: Object,
            required: true
        },
        editable: {
            type: Boolean,
            required: false,
            default: true
        },
        submitters: {
            type: Array,
            required: true
        },
        fields: {
            type: Array,
            required: true
        },
        selectedSubmitter: {
            type: Object,
            required: true
        }
    },
    emits: ['change-submitter', 'cancel'],
    data() {
        return {
            renderFieldTypeDropdown: false
        }
    },
    computed: {
        fieldNames: FieldType.computed.fieldNames,
        fieldIcons: FieldType.computed.fieldIcons,
        fieldIconsSorted() {
            if (this.fieldTypes?.length) {
                return this.fieldTypes.reduce((acc, type) => {
                    acc[type] = this.fieldIcons[type]
                    return acc
                }, {})
            } else {
                return this.fieldIcons
            }
        }
    },
    methods: {
        toggleFieldTypeDropdown() {
            this.renderFieldTypeDropdown = !this.renderFieldTypeDropdown
        },
        selectFieldType(type) {
            this.drawField.type = type
            this.renderFieldTypeDropdown = false

            // Update field options if needed
            if (['radio', 'multiple', 'select'].includes(type)) {
                this.drawField.options ||= [{ value: '', uuid: this.generateUuid() }]
            } else {
                delete this.drawField.options
            }
        },
        generateUuid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                const r = Math.random() * 16 | 0
                const v = c === 'x' ? r : (r & 0x3 | 0x8)
                return v.toString(16)
            })
        },
        removeSubmitter(submitter) {
            [...this.fields].forEach((field) => {
                if (field.submitter_uuid === submitter.uuid) {
                    this.removeField(field)
                }
            })

            this.submitters.splice(this.submitters.indexOf(submitter), 1)

            if (this.selectedSubmitter === submitter) {
                this.$emit('change-submitter', this.submitters[0])
            }

            this.save()
        },
        removeField(field) {
            this.fields.splice(this.fields.indexOf(field), 1)

            this.save()
        }
    }
}
</script>
